import { getActivitiesAsync } from 'API/order/activities/getActivitiesAsync';
import { createKeyedDataAsyncSlice } from 'store/createKeyedDataAsyncSlice';
import { convertDataToString } from '../../../utilities/queryString';

export const { slice: activitySlice, asyncAction: getActivitiesAsyncAction } = createKeyedDataAsyncSlice(
  'activitySlice',
  getActivitiesAsync,
  (t) => convertDataToString(t)
);
